module.exports = __webpack_public_path__ + "media/images/madagascar-c46e26816faf0e280804ba35f5dec094.svg";